export const constants = {
  TOOLBAR_ROW_TYPE: 'toolbar-row',
  DEFAULT_TOOLBAR_NAME: 'default-toolbar',
};
